<template>
    <div>
        <!-- @TODO: Add this to a reusable component -->
        <div class="text-center">
            <div class="logo-device text-center mb-6">
                <img :src="global.app.url + 'images/logo-device.svg'" alt="Options Desk O logo" title="Options Desk" />
            </div>

            <h1 class="text-xl uppercase font-semibold mb-5">Create an account</h1>
        </div>
        <!-- @ENDTODO -->

        <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(doHandleRegister)">
                <InputComponent
                    v-model="registerFormData.email"
                    type="email"
                    label="Email Address"
                    placeholder="Email Address"
                    :error="emailInputError"
                />

                <div class="mt-8">
                    <InputComponent
                        v-model="registerFormData.password"
                        vid="password"
                        name="password"
                        type="password"
                        rules="required|min:8"
                        label="Password"
                        placeholder="Password"
                        subtext="Minimum 8 characters with at least one number and one special character"
                    />
                </div>

                <div class="mt-8">
                    <InputComponent
                        v-model="registerFormData.password_confirmation"
                        name="password_confirm"
                        type="password"
                        rules="required|confirmed:password"
                        label="Confirm Password"
                        placeholder="Confirm Password"
                    />
                </div>

                <div class="mt-8">
                    <CheckboxComponent
                        id="terms-and-conditions"
                        name="terms-and-conditions"
                        label="I have read and agree to the <a href='https://optionsdesk.com/platform-privacy-policy/' class='text-green' target='_blank' rel='noreferrer noopener'>Platform Terms of Use</a> &amp; <a href='https://optionsdesk.com/platform-privacy-policy/' class='text-green' target='_blank' rel='noreferrer noopener'>Platform Privacy Policy</a>"
                    />
                </div>

                <div class="mt-2 text-center">
                    Already have an account?
                    <router-link :to="{ name: 'login' }" class="text-white">Click here</router-link>
                    to sign in.
                </div>

                <div class="mt-8">
                    <AlertComponent
                        :message="global.flashMessage.message"
                        :errors="global.flashMessage.errorList"
                        :color="global.flashMessage.color"
                    />
                </div>

                <div class="mt-8">
                    <ButtonComponent
                        id="apply-for-account"
                        type="submit"
                        color="primary"
                        label="Apply for an account"
                    />
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver } from "vee-validate";
import InputComponent from "@components/inputs/InputComponent";
import ButtonComponent from "@components/buttons/ButtonComponent";
import CheckboxComponent from "@components/inputs/CheckboxComponent";
import AlertComponent from "@components/misc/AlertComponent";

export default {
    name: "RegisterPage",
    props: {},
    components: {
        ValidationObserver,
        InputComponent,
        ButtonComponent,
        CheckboxComponent,
        AlertComponent,
    },
    computed: {
        ...mapGetters(["global"]),
    },
    data: function () {
        return {
            registerFormData: {
                email: "",
                password: "",
                password_confirmation: "",
            },
            emailInputError: "",
            acceptPrivacyPolicy: false,
            acceptPersonalDataProcessing: false,
        };
    },
    methods: {
        ...mapActions([
            "doRegisterUser",
            "doLogin",
            "showHideGlobalLoader",
            "setGlobalFlashResponse",
            "resetGlobalFlashResponse",
        ]),
        async doHandleRegister() {
            this.showHideGlobalLoader({ isLoading: true, label: "Creating Account..." });

            await new Promise((resolve) => setTimeout(resolve, 3000)); // Cheeky little sleep

            this.doRegisterUser(this.registerFormData).then(
                (response) => {
                    // If the response is good, let's log them in automatically
                    this.doLogin(this.registerFormData).then(
                        (response) => {
                            // Redirect to the main "Create Account" form
                            this.$router.push({ name: "create-account", params: { step: 1 } });
                            this.resetGlobalFlashResponse();
                            this.showHideGlobalLoader({ isLoading: false });
                            this.$gtm.trackEvent({
                                event: 'successful_registration',
                                category: "Registrations",
                                action: "Successful registration",
                                label: this.$route.path,
                            });
                        },
                        (error) => {
                            // This in theory should never be actioned due to the dependency on the previous Promise response. But putting it anyway for belts and braces
                            this.setGlobalFlashResponse({
                                message: "There was a problem trying to log you in, please check your credentials.",
                            });
                            this.$router.push({ name: "login" });
                            this.showHideGlobalLoader({ isLoading: false });
                        }
                    );
                },
                (error) => {
                    if (error.response.data.errors.email != undefined) {
                        this.setGlobalFlashResponse({
                            message: "The following problem(s) were found when trying to create your account:",
                            errorList: error.response.data.errors.email,
                        });
                        this.emailInputError = error.response.data.errors.email[0];
                        this.showHideGlobalLoader({ isLoading: false });
                    }
                }
            );
        },
    },
};
</script>
